import { Outlet } from "react-router";
import { Header } from "./Header";
import { BottomNav } from "./BottomNav";
import { InstallPrompt } from "./InstallPrompt";
import { ErrorBoundary } from "../ui/ErrorBoundary";
import { usePushNotifications } from "../../hooks/usePushNotifications";

export function Layout() {
  usePushNotifications();

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="mx-auto max-w-5xl px-4 pb-20 pt-6 sm:pb-6">
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </main>
      <BottomNav />
      <InstallPrompt />
    </div>
  );
}
